import cn from './blacklist.module.css';

const RecordEntityHeader = ({ titles }: { titles: string[] }) => (
  <div className={cn.recordEntityHeader}>
    {titles.map((item) => (
      <div
        className={cn.recordEntityHeaderTitle}
        key={item}
        style={{ width: `${100 / titles.length}%` }}
      >
        {item}
      </div>
    ))}
  </div>
);

export default RecordEntityHeader;
